module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";

	var webcam = require('webcamjs');
	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'warning': fox.i18n.getTranslation('warning', 'Warning', 'dialog'),
				'iUnderstand': fox.i18n.getTranslation('iUnderstand', 'I understand', 'dialog')
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('Popup_Profile_Snapshot', {
		configure: function() {
			this.registerOptions('', {
				autoRender: true,
				container: '#model-photo-passport',
				template: 'sitepage_profile_snapshot_main',
				showWarning: true,
				'widgets.snapshotFlash': {
					widget: 'Widget',
					group: 'main',
					'embed.container': '#childs-container',
					template: 'sitepage_profile_snapshot_flash',
					active: true,
					autoRender: true,
					handleWom: {
						renderPlayer: {
							event: 'addedToDom',
							widget: '@this',
							callback: '@parent:renderPlayer'
						}
					}
				},
				'widgets.snapshotPreview': {
					widget: 'Widget',
					group: 'main',
					'embed.container': '#childs-container',
					template: 'sitepage_profile_snapshot_preview',
					active: false,
					autoRender: true
				},
				'widgets.snapshotBtn': {
					widget: 'Widget',
					group: 'btns',
					autoRender: true,
					active: true,
					'embed.container': '.bottom-part > span.action-btns',
					template: 'sitepage_profile_snapshot_take',
					handleDom: {
						takeSnapshot: {
							target: '#take-snapshot',
							event: 'click',
							callback: '@parent:takeSnapshot'
						}
					}
				},
				'widgets.submitBtn': {
					widget: 'Widget',
					group: 'btns',
					autoRender: true,
					active: false,
					'embed.container': '.bottom-part > span.action-btns',
					template: 'sitepage_profile_snapshot_submitbtn',
					handleDom: {
						apply: {
							target: '#submit-photo',
							event: 'click',
							callback: '@parent:postScreenShot'
						},
						tryAgain: {
							event: 'click',
							target: '#try-again',
							callback: '@parent:hideScreenShot'
						}
					}
				},
				'widgets.uploadForm': {
					widget: 'Form',
					autoApply: true,
					loadValuesOnRun: false,
					formElements: {
						'upPhoto.element': {
							widget: 'Form_Element_FileUploaderSimple',
							autoSubmit: true,
						}
					}
				},
				'widgets.uploader': {
					widget: 'Skin_Form_ImageSelectSimple',
					createStorageResource: true
				},
				'widgets.warning': {
					widget: 'PopupWidget',
					template: '',
					title: _.getTranslation('warning') + '!',
					dialog: {
						width: '550px',
						dialogClass: 'dlg-amc dark-overlay dlg-amc-error',
						buttons: [{text: _.getTranslation('iUnderstand'), 'class': 'mc-btn btn-small btn-casual', id: 'close-mes'}]
					},
					'widgets.message': {
						widget: 'Widget',
						autoRender: true,
						template: 'sitepage_profile_snapshot_warning_popup',
						'handleDom.closeW': {
							event: 'click',
							target: '#close-mes',
							targetWidget: '@parent',
							callback: '@parent:hide'
						}
					}
				},
				handleWom: {
					switchState: {
						event: 'switchState',
						widget: '#uploadForm #upPhoto',
						callback: 'onUploadFile'
					}
				},
				handleDom: {
					closeFlash: {
						event: 'click',
						target: '#close-snapshot-flash',
						callback: 'hideWindow'
					},

					uploadFromPC: {
						event: 'change',
						target: '#upload-file',
						callback: '#uploadForm #upPhoto:changeHandler'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		setField: function(field) {
			this._field = field;

			return this;
		},

		init: function() {
			this._field = false;
			this._warningIsShowed = false;
			
			this.webcam = webcam;

			this.callParent('init', arguments);
		},

		running: function() {
			this._upPW = this.rwom1('#uploadForm #upPhoto');

			this.callParent('running', arguments);
		},

		renderPlayer: function() {
			navigator.mediaDevices.getUserMedia({video: true})
				.then(function() {
					var h = document.body.clientHeight;
					var ar = 4 / 3;
					var w = h * ar;

					webcam.set({
						image_format: 'jpeg',
						jpeg_quality: 90
					});

					webcam.set({
						width: w,
						height: h,
						constraints: {
							width: w,
							height: h
						}
					});

					webcam.setSWFLocation(require('webcamjs/webcam.swf'));
					webcam.attach('#flash-container');
				}.bind(this)).catch(function(error) {
					console.log('navigator.getUserMedia error: ', error);
				}.bind(this));
		},

		showWarning: function () {
			if (!this.getOption('showWarning'))
				return fox.Promise.resolve(true);

			if (!this._warningIsShowed) {
				this.rwom1('#warning').show();

				this._warningIsShowed = true;

				return this.wait('#warning', 'hide');
			}

			return fox.Promise.resolve(true);
		},

		takeSnapshot: function() {
			this.showWarning().then(function () {
				this.showScreenShot()
					.switchEmbeddedWidget('submitBtn');
			}.bind(this));
		},

		showScreenShot: function() {
			webcam.snap(function (uri) {
				var container = this.rwom1('#snapshotFlash').dom1('#snap-result-container');
				var preview = this.rwom1('#snapshotPreview');

				preview.setTemplateOptions('path', uri);
				this.switchEmbeddedWidget('snapshotPreview');

				this._uri = uri;
			}.bind(this));

			return this;
		},

		hideScreenShot: function() {
			if (this.rwom1('#submitBtn').isActive()) {
				this.switchEmbeddedWidget('snapshotBtn');

				var preview = this.rwom1('#snapshotPreview');

				if (!this.rwom1('#snapshotFlash').isEmbedded()) {
					delete preview.templateOptions.path;
					delete this._uri;

					this.switchEmbeddedWidget('snapshotFlash');
				}
			}

			return this;
		}, 

		postScreenShot: function() {
			if (this._uri) {
				fox.dom.addClass('spin', this.rwom1('#submitBtn').dom1('#submit-photo'));
				this.rwom1('#uploader').postProcess(this._uri).then(function () {
					fox.dom.removeClass('spin', this.rwom1('#submitBtn').dom1('#submit-photo'));
					var resId = this.rwom1('#uploader').getResourceId();

					this.onScreenShotPost({response: {id: resId}});
					
					return delete this._uri;
				}.bind(this)).catch(function (e) {
					fox.dom.removeClass('spin', this.rwom1('#submitBtn').dom1('#submit-photo'));

					console.error && console.error(e);
				}.bind(this));
			} else {
				this.onScreenShotPost(this._upPW.fileInfo);
			}
		},

		onScreenShotPost: function(params) {
			if (params.response) {
				params = params.response;
			}

			switch(this._field) {
				case 'facePhoto':
					this.dispatchEvent('onScreenShotPostFacePhoto', params);
					break;
				case 'faceIdPhoto':
					this.dispatchEvent('onScreenShotPostFaceIdPhoto', params);
					break;
				default:
					this.dispatchEvent('post_screenshot', fox.merge({}, params, { field: this._field }));
			}
		
			fox.dom.removeClass('spin', this.rwom1('#submitBtn').dom1('#submit-photo'));

			this.hideWindow();
		},

		activate: function (field) {
			this.setField(field.alias);
		
			this.callParent('activate', arguments);
		},

		hideWindow: function () {
			if (this.rwom1('#submitBtn').isActive()) {
				this.switchEmbeddedWidget('snapshotBtn');
			}

			if (this.rwom1('#snapshotPreview').isActive()) {
				this.switchEmbeddedWidget('snapshotFlash');
			}

			if (!fox.utils.safari())
				webcam.reset();

			this.deactivate()
				.removeFromDom();
		},

		onUploadFile: function (state) {
			if (state === 'progress') {
				fox.dom.addClass('spin', this.dom1('.up-file'));
			} else  if (state === 'failed') {
				var n;

				fox.dom.removeClass('spin', this.dom1('.up-file'));
				if ((n = this.getParent().wom1('#notices'))) {
					n.add({
						alias: 'uploadError',
						message: 'Upload error',
						type: 'error'
					}, true);
				}
			} else if (state === 'exists') {
				var w = this.rwom1('#snapshotPreview');
				
				w.setTemplateOptions(this._upPW.fileInfo);

				if (w.isActive()) {
					w.render();
				} else {
					this.switchEmbeddedWidget('snapshotPreview');
				}

				fox.dom.removeClass('spin', this.dom1('.up-file'));
				this.switchEmbeddedWidget('submitBtn');
			}
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/popup/profile/snapshot.js
// module id = 344
// module chunks = 2